module.exports = __webpack_public_path__ + "static/img/vote_share.6570ae6.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/vote/vote_share.png
// module id = OFx7
// module chunks = 1